// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Of46","name":"Header_name__31sol","birthday":"Header_birthday__2Oz5Q","skeleton":"Header_skeleton__2ogdD"};